module.exports = __webpack_public_path__ + "img/content-04.b7bbb61d.jpg";